import z from 'zod';

export const loginBusinessFIResponseSchema = z.object({ authenticationUrl: z.string() });

export const loginWithSessionIdResponseSchema = z.object({ authToken: z.string() });
